import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, concatMap } from 'rxjs/operators';
import { Action } from 'redux';
import { UpdateOwnershipField, ReassignSplits } from '../action-creators';
import { UPDATE_OWNERSHIP_FIELD } from '../actions';
import AppState from '../../state';
import { getOwnershipTotal } from '../selectors';
import { SplitUpdate } from '@services/ownership/types/split-update';
import { assetOwners } from '@webapp/store/ownership/selectors';
import { keyDebounceTime } from '../../operators';

export const autosaveEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, UpdateOwnershipField<any>>(UPDATE_OWNERSHIP_FIELD),
    keyDebounceTime(
      2000,
      (action) => `${action.assetId}-${action.ownershipId}`
    ),
    withLatestFrom(state$),
    concatMap(([actions, state]) => {
      return actions
        .filter((action) => {
          return !!(
            action.assetId in state.ownership.assets &&
            action.ownershipId in state.ownership.assets[action.assetId] &&
            getOwnershipTotal(
              state.ownership,
              action.assetId,
              state.ownership.assets[action.assetId][action.ownershipId]
                .ownershipType
            ) <= 100
          );
        })
        .map((action) => {
          const type =
            state.ownership.assets[action.assetId][action.ownershipId]
              .ownershipType;
          const owners = assetOwners(state.ownership, action.assetId, type);

          const updates: SplitUpdate[] = Object.values(owners).map((o) => ({
            assetId: o.assetId,
            ownershipId: o.id,
            split: o.split,
          }));

          return new ReassignSplits(action.assetId, type, updates, []);
        });
    })
  );
